import { useEffect, useState } from "react";
import { Route, Routes, useLocation } from "react-router-dom";
import LandingPage from "./pages/LandingPage/LandingPage";
import ShopPage from "./pages/ShopPage/ShopPage";
import Header from "./components/header/Header";
import Footer from "./components/Footer";
import ContactPage from "./pages/ContactPage/ContactPage";
import CartSection from "./pages/cartPage/CartPage";
import AboutUsPage from "./pages/AboutUsPage/AboutUsPage";
import { Provider, useDispatch, useSelector } from "react-redux";
import { store } from "./store/index";
import CouponsPage from "./pages/CouponsPage/CouponsPage";
import SignUpPage from "./pages/SignupPage/SignUpPage";
import LoginPage from "./pages/LoginPage/LoginPage";

import AccountPage from "./pages/AccountPage/AccountPage";
import ResetPasswordPage from "./pages/ResetPasswordPage/ResetPasswordPage";

import ModelsPage from "./pages/ModelsPage/ModelsPage";
import ConfirmOrderPage from "./pages/GlobalPages/ConfirmOrderPage";
import SidebarDrawer from "./components/mobileMenu/SidebarDrawer";
import useIsMobile from "./hooks/useIsMobile";
import MobileHeader from "./components/mobileMenu/MobileHeader";
import { useGetBrands } from "./hooks/useGetBrands";
import { useGetLocations } from "./hooks/useGetLocations";
import Loader from "./components/UI/loader/Loader";
import LocationsPage from "./pages/LocationPage/LocationPage";
import { RootState } from "./store/ducks";
import {
  updateSelectedLocation,
  updateUser,
  updateUserSystemId,
} from "./store/ducks/app";
import LoginGuestModal from "./components/modal/LoginGuestModal";
import ChangeLocationModal from "./components/modal/ChangeLocationModal";
import ScrollToTop from "./components/ScrollToTop";
import AuthGuard from "./components/authGuard/AuthGuard";
import NotFound404Page from "./pages/GlobalPages/NotFound404Page";
import AuthGuardLogin from "./components/authGuard/AuthGuardLogin";
import PrivacyPolicy from "./pages/privacypolicy/PrivacyPolicy";
import { Grid } from "@mui/material";
import NewSearch from "./components/NewSearch/NewSearch";
import UserOrderDetailsPage from "./pages/UserSalesOrderPage/UserOrderDetailsPage";
import UserOrdersPage from "./pages/UserSalesOrderPage/UserOrdersPage";
import UserInvoicesDetailsPage from "./pages/UserInvoicesPage/UserInvoicesDetailsPage";
import UserInvoicesPage from "./pages/UserInvoicesPage/UserInvoicesPage";
import { Helmet } from "react-helmet";
import { menuItems } from "./constants/JsonObjects";

function App() {
  const location = useLocation();
  const dispatch = useDispatch();
  const { web } = useIsMobile();

  const { setSelectedLocation, locationsLoading , fetchData } = useGetLocations();

  const { brandsLoading, brands } = useGetBrands();
  useEffect(()=>{
    fetchData();
  
  },[])
  const userStore = useSelector((state: RootState) => state?.store?.user);
  const locationsStore = useSelector(
    (state: RootState) => state?.store?.locations
  );
  const selectedLocationStore = useSelector(
    (state: RootState) => state?.store?.selectedLocation
  );
  // const userSystemIdStore = useSelector((state: RootState) => state?.store?.userSystemId);

  // const [userSystemId, setUserSystemId] = useState(userSystemIdStore);
  const [openMobileMenu, setOpenMobileMenu] = useState(false);
  const [openWelcomeModal, setOpenWelcomeModal] = useState(true);
  const [locationModalOpen, setLocationModalOpen] = useState(false);

  const handleOpenMobileMenu = () => {
    // console.log("?", openMobileMenu);
    setOpenMobileMenu(!openMobileMenu);
  };

  const handleLocationChange = (event: any) => {
    setSelectedLocation(event.target.value);
    localStorage.setItem("location", JSON.stringify(event.target.value));
    dispatch(updateSelectedLocation(event.target.value));
    dispatch(updateUserSystemId(event.target.value.guestCutomerId));
    dispatch(updateUser("guest"));
  };

  useEffect(() => {
    // console.log("location.pathname: ", location.pathname);
    const noModalPaths = ["/login", "/signup", "/forgotPass", "/resetpassword"];

    if (userStore !== null && userStore !== "" && userStore !== "guest") {
      // "", "guest", USER
      setOpenWelcomeModal(false);
      dispatch(updateUserSystemId(userStore.id));
    } else if (userStore !== null && userStore === "guest") {
      // console.log(userStore);
      setOpenWelcomeModal(false);
    } else if (
      userStore !== null &&
      userStore === "" &&
      !noModalPaths.includes(location.pathname)
    ) {
      // console.log("3");

      setOpenWelcomeModal(true);
      dispatch(updateUser("guest"));
    } else {
      setOpenWelcomeModal(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location, userStore]);

  if (brandsLoading) return <Loader />;
  // else {
    return (
      <Provider store={store}>
        <>
          {web ? (
            <Header
              handleOpenMobileMenu={handleOpenMobileMenu}
              brands={brands}
              locationsLoading={locationsLoading}
            />
          ) : (
            <MobileHeader
              handleOpenMobileMenu={handleOpenMobileMenu}
              brands={brands}
              locationsLoading={locationsLoading}
            />
          )}
          {
            <SidebarDrawer
              open={openMobileMenu}
              setOpen={handleOpenMobileMenu}
              brands={brands}
              // locations={locations}
            />
          }
        </>
        {location.pathname !== "/" && (
          <Grid
            container
            sx={{
              padding: "30px",
              display: "flex",
              flexDirection: "row",
              justifyContent: "flex-end",
            }}
          >
            <Grid item xl={3} lg={3} md={3} sm={12} xs={12}>
              <NewSearch />
            </Grid>
          </Grid>
        )}

        {/*<LoginGuestModal
          open={openWelcomeModal}
          setOpen={setOpenWelcomeModal}
          setLocationModalOpen={setLocationModalOpen}
        />/*}

        {/*<ChangeLocationModal
          open={locationModalOpen}
          setOpen={setLocationModalOpen}
          locations={locationsStore}
          selectedLocation={selectedLocationStore}
          handleLocationChange={handleLocationChange}
      />*/}

        <ScrollToTop />
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/shop" element={<ShopPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/cart" element={<CartSection />} />
          <Route path="/aboutUs" element={<AboutUsPage />} />
          <Route path="/location" element={<LocationsPage />} />
          <Route path="/coupons" element={<CouponsPage />} />
          <Route
            path="/signup"
            element={
              <AuthGuardLogin>
                <SignUpPage />{" "}
              </AuthGuardLogin>
            }
          />
          <Route
            path="/login"
            element={
              <AuthGuardLogin>
                <LoginPage />{" "}
              </AuthGuardLogin>
            }
          />
          <Route
            path="/accountPage"
            element={
              <AuthGuard>
                <AccountPage />
              </AuthGuard>
            }
          />
          <Route
            path="/forgotPass"
            element={
              <AuthGuardLogin>
                <ResetPasswordPage />{" "}
              </AuthGuardLogin>
            }
          />
          <Route
            path="/resetpassword"
            element={
              <AuthGuardLogin>
                <ResetPasswordPage />{" "}
              </AuthGuardLogin>
            }
          />
          <Route
            path="/myInvoices"
            element={
              <AuthGuard>
                <UserInvoicesPage />
              </AuthGuard>
            }
          />
          <Route
            path="/invoiceDetails/:invoiceId"
            element={
              <AuthGuard>
                <UserInvoicesDetailsPage />
              </AuthGuard>
            }
          />
          <Route
            path="/mySalesOrders"
            element={
              <AuthGuard>
                <UserOrdersPage />
              </AuthGuard>
            }
          />
          <Route
            path="/salesOrderDetails/:OrderId"
            element={
              <AuthGuard>
                <UserOrderDetailsPage />
              </AuthGuard>
            }
          />
          <Route path="/models" element={<ModelsPage />} />
          {/* <Route path="/Tire-Brands/:selectedBrand" element={<ModelsPage />} /> */}
          {brands?.map((item: any, index:number) => {
            return (
              <Route
                key={item.Code + " " + index}
                path={`/Tire-Brands/${item.Code.replace(" ","-")}`} element={<ModelsPage selectedBrand={item.Code}/>}
              />
            );
          })}
          <Route path="/confirmOrder" element={<ConfirmOrderPage />} />
          <Route path="/Error404" element={<NotFound404Page />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
        </Routes>
        <Footer />
      </Provider>
    );
  }
// }

export default App;
